export default __webpack_public_path__ + "static/media/logout.1e99ce77.svg";